// 九号的带文案logo -- segway store
const LogoPcIcon = ({ width = 120, height = 24, color = '#fff' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 120 24"
    fill="none">
    <path
      d="M12 0C5.37233 0 0 5.37233 0 12C0 18.6277 5.37233 24 12 24C18.6277 24 24 18.6277 24 12C24 5.37233 18.6277 0 12 0ZM4.14381 11.1347C4.14381 10.7885 4.42413 10.5107 4.76782 10.5107H12.5363C12.88 10.5107 13.1603 10.791 13.1603 11.1347C13.1603 11.4784 12.8824 11.7562 12.5363 11.7562H4.76782C4.42413 11.7562 4.14381 11.4784 4.14381 11.1347ZM15.8562 12.1755C15.8562 12.1755 14.028 18.028 13.6648 19.1761C13.1481 20.8068 11.3516 21.5454 9.85009 20.8653C8.33394 20.1755 8.59476 18.7495 8.72639 18.3303L9.5064 15.8245C9.71603 15.1444 9.7794 14.7593 9.46983 14.2864C9.11883 13.7892 8.47044 13.8184 8.23888 13.8184H7.33943C6.99573 13.8184 6.71785 13.5405 6.71785 13.1968C6.71785 12.8531 6.99573 12.5728 7.33943 12.5728H11.0104C11.8537 12.5728 12.2657 13.0408 11.8708 13.8184L9.90128 17.7136C9.52102 18.457 9.50884 19.3857 10.3522 19.7416C11.3979 20.1828 12.2828 19.4223 12.5948 18.418C12.741 17.9476 14.6691 11.7952 14.6691 11.7952C14.8397 11.2614 14.9762 10.6325 14.6399 10.1548C14.3254 9.70871 13.6283 9.68921 13.3967 9.68921H6.45948C6.11578 9.68921 5.8379 9.41133 5.8379 9.0652C5.8379 8.71907 6.11578 8.44119 6.45948 8.44119H13.4089C13.6746 8.44119 14.908 8.41682 15.6368 9.35283C16.1828 10.05 16.2389 10.9787 15.8562 12.1731V12.1755ZM15.2565 7.8245C14.1012 7.8245 13.1627 6.88604 13.1627 5.73065C13.1627 4.57526 14.1012 3.63681 15.2565 3.63681C16.4119 3.63681 17.3504 4.57282 17.3504 5.73065C17.3504 6.88848 16.4119 7.8245 15.2565 7.8245Z"
      fill={color}
    />
    <path
      d="M88.5872 17.3995H86.5431L85.4931 14.4875H81.6712L80.6212 17.3995H78.5771L82.5951 6.68945H84.5831L88.5872 17.3995ZM83.5471 9.27945L82.3292 12.6675H84.8491L83.6311 9.27945H83.5471Z"
      fill={color}
    />
    <path
      d="M72.2042 17.3995H68.3682V6.68945H72.4422C75.7882 6.68945 77.5802 8.84545 77.5802 12.0375C77.5802 15.2435 75.6902 17.3995 72.2042 17.3995ZM70.3002 15.5935H72.2042C74.4722 15.5935 75.5922 14.2495 75.5922 12.0375C75.5922 9.83945 74.5142 8.49545 72.3162 8.49545H70.3002V15.5935Z"
      fill={color}
    />
    <path
      d="M58.8386 17.3995H56.9766V6.68945H58.7406L63.7386 13.9275H63.8226V6.68945H65.6846V17.3995H64.0046L58.9366 10.1475H58.8386V17.3995Z"
      fill={color}
    />
    <path
      d="M49.472 12.7795V15.6355H54.694V17.3995H47.54V6.68945H54.526V8.45345H49.472V11.0155H54.246V12.7795H49.472Z"
      fill={color}
    />
    <path d="M44.849 6.68945V17.3995H42.917V6.68945H44.849Z" fill={color} />
    <path
      d="M37.7142 17.3995H35.7822V8.49545H32.6182V6.68945H40.8642V8.49545H37.7142V17.3995Z"
      fill={color}
    />
  </svg>
)
export default LogoPcIcon
